import React from 'react';

export interface EmptyCellProps {
  promotion?: any;
  game?: any;
  editable?: boolean;
}

function EmptyCell({ promotion, game, editable }: EmptyCellProps) {
  return <div className="grid-empty">---</div>;
}

export default EmptyCell;
